export default "__VITE_ASSET__eab36bd6__"